export class SelectedLevelTemplate {
    constructor(bucket, value) {
        this.value = value;
        this.bucket = bucket;
    }
}

export const BucketType = {
    year: 'year',
    makeModel: 'makeModel',
    bodyStyles: 'bodyStyles',
    colors:'colors',   
    features: 'features',
    options: 'options',
    trims: 'trims',
    location: 'location'    
}
